module.exports = __webpack_public_path__ + "static/media/sofar-ocean-screens.526c2d88.png";